import React, {useState, useEffect} from "react";
import {Swiper, SwiperSlide} from "swiper/react";

import {EffectFade} from "swiper/modules";
import {Autoplay, Pagination} from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import {BannerInterface} from "../../interfaces/core/BannerInterface";

export default function SlideBanners({banners}: {banners: BannerInterface[]}) {
    return (
        <section className="kv mb">
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <div className="kv__wrap">
                            <Swiper
                                pagination={{
                                    el: ".dots",
                                    clickable: true,
                                    renderBullet: function (index: number, className: string) {
                                        return (
                                            '<li class="' +
                                            className +
                                            '">' +
                                            '<button><i class="progressing progress-circle"></i></button>' +
                                            "</li>"
                                        );
                                    },
                                }}
                                breakpoints={{
                                    992: {
                                        pagination: {
                                            renderBullet: function (index: number, className: string) {
                                                return (
                                                    '   <button class=" ' +
                                                    className +
                                                    '"><svg class="progress-circleSl" width="100" height="100" viewBox="0 0 100 100" stroke-alignment="outer stroke"><circle class="circle-origin" r="49" cx="50" cy="50"></circle></svg><span>' +
                                                    (index + 1) +
                                                    "</span></button>"
                                                );
                                            },
                                        },
                                    },
                                }}
                                autoplay={{
                                    delay: 25000,
                                }}
                                modules={[Autoplay, Pagination, EffectFade]}
                                effect={"fade"}
                                loop={true}
                                className="kv__slider"
                            >
                                {banners &&
                                    banners.map((banner, index) => (
                                        <SwiperSlide key={index}>
                                            <a className="slide-wrap banner"  href={banner.url}>
                                                {banner.image ? (
                                                    <picture className="banner__img">
                                                        {banner.imageMob ? (
                                                            <source
                                                                srcSet={banner.imageMob}
                                                                media="(max-width: 992px)"
                                                            />
                                                        ) : (
                                                            <source srcSet={banner.image} media="(max-width: 992px)" />
                                                        )}
                                                        <img src={banner.image} alt="" />
                                                    </picture>
                                                ) : (
                                                    ""
                                                )}

                                                {banner.video ? (
                                                    <>
                                                        {banner.videoMob ? (
                                                            <>
                                                                <video
                                                                    className="banner__img banner__video-desc"
                                                                    src={banner.video}
                                                                    autoPlay
                                                                    playsInline
                                                                    loop
                                                                    muted
                                                                ></video>
                                                                <video
                                                                    className="banner__img banner__video-mob"
                                                                    src={banner.videoMob}
                                                                    autoPlay
                                                                    playsInline
                                                                    loop
                                                                    muted
                                                                ></video>
                                                            </>
                                                        ) : (
                                                            <video
                                                                className="banner__img banner__video-desc"
                                                                src={banner.video}
                                                                autoPlay
                                                                playsInline
                                                                loop
                                                                muted
                                                            ></video>
                                                        )}
                                                    </>
                                                ) : (
                                                    ""
                                                )}

                                                <h1 className="banner__title f-exp">{banner.title}</h1>
                                                <p className="banner__text">{banner.description}</p>
                                                <a className="btn btn-primary" href={banner.url}>
                                                    {banner.buttonText}
                                                </a>
                                            </a>
                                        </SwiperSlide>
                                    ))}

                                <div className="slider-progress hidden">
                                    <div className="progressing progress-bar"></div>
                                </div>
                                <div className="kv__slider-dots">
                                    <div className="dots"></div>
                                </div>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
